// @flow
import React from "react";
import type { FlagContentProps } from "../types";

const SouthAfrica = ({ circular }: FlagContentProps) =>
  circular ? (
    <React.Fragment>
      <g clipPath="url(#clip0_21_51)">
        <rect width="20" height="20" rx="10" fill="white" />
        <rect x="-2.40002" width="28.4" height="8.98876" fill="#DE3131" />
        <rect
          x="-2.40002"
          y="11.0112"
          width="28.4"
          height="8.98876"
          fill="#2959A3"
        />
        <path
          d="M-6 0H0.4L11.04 6.66667H26V13.3333H11.04L0.4 20H-6V0Z"
          fill="white"
        />
        <path
          d="M-6 0H-2.12L10.6 7.97753H26V12.0225H10.6L-2.12 20H-6V0Z"
          fill="#329A47"
        />
        <path d="M-6 2.43446L6.16 9.99999L-6 17.5655V2.43446Z" fill="#FFC642" />
        <path d="M-6 4.00749L3.59999 10L-6 15.9925V4.00749Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_21_51">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <rect x="3.59998" width="28.4" height="8.98876" fill="#DE3131" />
      <rect
        x="3.59998"
        y="11.0112"
        width="28.4"
        height="8.98876"
        fill="#2959A3"
      />
      <path
        d="M0 0H6.4L17.04 6.66667H32V13.3333H17.04L6.4 20H0V0Z"
        fill="white"
      />
      <path
        d="M0 0H3.88L16.6 7.97753H32V12.0225H16.6L3.88 20H0V0Z"
        fill="#329A47"
      />
      <path d="M0 2.43446L12.16 9.99999L0 17.5655V2.43446Z" fill="#FFC642" />
      <path d="M0 4.00749L9.59999 10L0 15.9925V4.00749Z" fill="black" />
    </React.Fragment>
  );

// $FlowFixMe
export default React.memo(SouthAfrica);
